/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface JureSearch
 */
export interface JureSearch {
    /**
     * 
     * @type {number}
     * @memberof JureSearch
     */
    idClasseMatiere?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof JureSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof JureSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof JureSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JureSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof JureSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof JureSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the JureSearch interface.
 */
export function instanceOfJureSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JureSearchFromJSON(json: any): JureSearch {
    return JureSearchFromJSONTyped(json, false);
}

export function JureSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): JureSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idClasseMatiere': !exists(json, 'idClasseMatiere') ? undefined : json['idClasseMatiere'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function JureSearchToJSON(value?: JureSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idClasseMatiere': value.idClasseMatiere,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

